import classNames from 'classnames';
import { ButtonHTMLAttributes } from 'react';

export function DebugButton(props: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button {...props} className={classNames('px-2 py-1.5 bg-cyan-500 hover:bg-cyan-600 rounded disabled:bg-gray-400 disabled:hover:bg-gray-400', props.className)} />
  )
}
